<template>
  <section class="table-referee-type-events">
    <BCarousel :interval="5000" :autoplay="false" :indicator-inside="false" :pause-info="false" :progress="false">
      <template v-for="(arrayPage, indexPage) in referees">
        <BCarouselItem :key="indexPage">
          <div class="table-activetime-by-type">
            <div class="table-activetime-by-type__header">
              <div class="table-activetime-by-type__header__pos">Pos</div>
              <div class="table-activetime-by-type__header__team">Arbitro</div>
              <div class="table-activetime-by-type__header__ta" @click="orderReferee('time')">
                <img
                  v-if="orderTime == 0"
                  src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_cronometro_flecha_01.png"
                />
                <img
                  v-if="orderTime == 1"
                  src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_cronometro_flecha_02.png"
                />
              </div>

              <div class="table-activetime-by-type__header__ti" @click="orderReferee('event')">
                <img v-if="orderEvents == 0" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_numero_flecha_01.png" />
                <img v-if="orderEvents == 1" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_numero_flecha_02.png" />
              </div>
            </div>
            <template v-for="(item, index) in arrayPage">
              <div :key="index" class="table-activetime-by-type__row">
                <div class="table-activetime-by-type__row__pos">{{ item.pos }}</div>
                <div class="table-activetime-by-type__row__shield">
                  <img :src="item.logo" />
                </div>
                <div class="table-activetime-by-type__row__team">{{ item.name }}</div>
                <div class="table-activetime-by-type__row__ta">{{ item.time }}</div>
                <div class="table-activetime-by-type__row__ti">
                  {{ item.average }}
                </div>
              </div>
            </template>
          </div>
        </BCarouselItem>
      </template>
    </BCarousel>
  </section>
</template>

<script>
export default {
  name: 'TableRefereeTypeEvents',
  props: {
    referees: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      orderTime: 0,
      orderEvents: 0,
    };
  },
  methods: {
    orderReferee(type) {
      var orderValue = 0;
      if (type == 'time') {
        orderValue = this.orderTime;
      } else {
        orderValue = this.orderEvents;
      }
      this.$emit('orderReferee', { type: type, order: orderValue });
      if (type == 'time') {
        if (this.orderTime == 0) {
          this.orderTime = 1;
        } else {
          this.orderTime = 0;
        }
      } else {
        if (this.orderEvents == 0) {
          this.orderEvents = 1;
        } else {
          this.orderEvents = 0;
        }
      }
    },
  },
  created() {},
};
</script>
<style>
.table-referee-type-events .carousel .carousel-indicator .indicator-item {
  margin-top: -49px;
}
.table-referee-type-events .carousel .carousel-indicator .indicator-item .indicator-style {
  width: 12px;
  height: 4px;
  border-radius: 2px;
  background-color: #c0c0c0c7;
  border: none;
}

.table-referee-type-events .carousel .carousel-indicator .indicator-item:not(:last-child) {
  margin-right: 0.1rem;
}
.table-referee-type-events .carousel .carousel-indicator .indicator-item .indicator-style:hover {
  background: rgb(128, 128, 128) !important;
}
.table-referee-type-events .carousel .carousel-indicator .indicator-item.is-active .indicator-style {
  background: #00a5ff;
}
.table-referee-type-events .carousel .carousel-indicator.is-inside.is-bottom {
  bottom: -80px !important;
}
.table-referee-type-events .carousel-arrow .icon.has-icons-right {
  right: 1% !important;
  top: 90% !important;
}
.table-referee-type-events .carousel-arrow .icon.has-icons-left {
  left: 1% !important;
  top: 90% !important;
}
.table-referee-type-events .carousel-arrow.is-hovered {
  opacity: 1 !important;
}
.table-referee-type-events .carousel-arrow .icon {
  width: 40px;
  height: 24px;
  opacity: 0.5;
  border-radius: 6px;
  background-color: rgba(19, 40, 57, 0.4);
}
.table-referee-type-events .carousel-arrow .icon:hover {
  border: 1px solid #7e7e7e;
}
.table-referee-type-events .carousel-arrow .icon {
  color: white;
}
</style>
<style lang="scss" scoped>
.table-referee-type-events {
  width: 100%;
  height: 204px;
}
.table-activetime-by-type {
  width: 100%;
  height: auto;
  padding-bottom: 37px;
  // background: gray;
  &__header {
    width: 100%;
    height: 28px;
    border-radius: 6px;
    background-color: #f7fafc;
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: -0.24px;
    text-align: center;
    color: #132839;
    font-family: 'Avenir-Demi';
    &__pos {
      width: 11.7%;
      // background: rgb(51, 47, 47);
    }
    &__team {
      width: 44.32%;
      margin-left: 1.71%;
      // background: rgb(51, 47, 47);
    }
    &__ta {
      width: 19.85%;
      margin-left: 1.71%;
      // background: rgb(51, 47, 47);
    }
    &__ti {
      width: 19.85%;
      margin-left: 1.71%;
      // background: rgb(51, 47, 47);
    }
  }
  &__row {
    width: 100%;
    height: 28px;
    // background-color: #def103;
    margin-top: 6px;
    display: inline-flex;
    align-items: center;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 28px;
    letter-spacing: -0.24px;
    text-align: center;
    color: #132839;
    &__pos {
      width: 11.7%;
      background-color: #f7fafc;
      font-size: 12px;
      height: 28px;
      font-family: 'Avenir-Demi';
      border-radius: 6px;
    }
    &__shield {
      width: 8.5%;
      margin-left: 1.71%;
      height: 28px;
      img {
        width: 24px;
      }
    }
    &__team {
      width: 34.39%;
      text-align: left !important;
      padding-left: 3%;
      margin-left: 1.71%;
      height: 28px;
      background-color: #f7fafc;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 13px;
      font-family: 'Avenir-Medium';
    }
    &__ta {
      width: 19.85%;
      margin-left: 1.71%;
      background-color: #edf4f9;
      font-size: 14px;
      height: 28px;
      border-radius: 6px;
      font-family: 'Avenir-Demi';
    }
    &__ti {
      width: 19.85%;
      margin-left: 1.71%;
      border-radius: 6px;
      height: 28px;
      background-color: #edf4f9;
      font-size: 14px;
      font-family: 'Avenir-Demi';
      &__medium {
        font-family: 'Avenir-Medium';
        font-size: 11px;
        margin-left: 1px;
      }
    }
  }
}
</style>
